import { Typography } from "@mui/material"
import React from "react"
import { styled } from "@mui/material/styles"

import { Parallax } from "react-scroll-parallax"
import { ReactComponent as Slashes } from "../assets/slashes.svg"
import { Box, SxProps } from "@mui/system"

interface IState {}

interface IProps {
  children?: React.ReactNode
  variant:
      "body2"
    | "caption"
    | "h5"
    | "h6"
  lightBg: boolean
  sx?: SxProps
}

class HeadingSmall extends React.Component<IProps, IState> {
  static defaultProps: IProps = { variant: "caption", lightBg: true }

  constructor(props: IProps) {
    super(props)
    this.state = {}
  }

  render() {
    const fgColor = this.props.lightBg ? "primary.main" : "primary.contrastText"

    return (
      <>
        <Box display="flex" flexDirection="row" justifyContent="center" width="100%">
          <Typography
            sx={{
              ...this.props.sx,
              borderBottom: `1px solid`,
              margin: "0.5rem"
            }}
            variant={this.props.variant}
            color={fgColor}
            align="center"
          >
            {this.props.children}
          </Typography>
        </Box>
      </>
    )
  }
}

export default HeadingSmall
